import '../../App.css';
import Seo from '../../components/common/atoms/Seo';
import seoData from '../../json/seo.json';
import textData from '../../json/text.json';
import Header from '../../components/menu/organisms/Header';
import Footer from  '../../components/footer/Footer';
import TopicPath from '../../components/common/atoms/TopicPath';
import H1 from '../../components/common/atoms/H1';
import OverviewContent from '../../components/company/organisms/OverviewContent';
import StaffContent from '../../components/company/organisms/StaffContent';

/**
 * 企業概要ページ
 * @returns 
 */
function Overview() {
  const links = [{link:'/overview', pageName:textData['menu.company.overview']['ja']}];
  const titleText = textData['menu.company.overview']['ja'];
  return (

    <div>
      {/* <BackgroundAnimation /> */}
      <Seo title={titleText} description={seoData.pages.overview.description} path='/overview' />

      <header>
        <Header />
      </header>
      
      <main className="main-content">
        <TopicPath links={links} />
        <H1 text={titleText}/>
        <OverviewContent />
        <StaffContent />
      </main>
      <footer>
        <Footer />
      </footer>

    </div>
  );
}

export default Overview;
